export default "__VITE_ASSET__02e00ded__"